import { createFileRoute } from '@tanstack/react-router';
import { WebhookHealthPanel } from '../../components/WebhookHealthPanel';

function WhatsAppWebhookHealthPage() {
  return (
    <WebhookHealthPanel
      object="whatsapp_business_account"
      title="WhatsApp webhook health"
      objectLabel="whatsapp_business_account"
      productNoun="WhatsApp"
    />
  );
}

export const Route = createFileRoute('/central/whatsapp-webhook-health')({
  component: WhatsAppWebhookHealthPage,
});
